<template>
  <div>
    <vs-dropdown v-if="loggedIn" vs-custom-content vs-trigger-click class="cursor-pointer mr-2">

      <div class="con-img ml-2">
        <img key="onlineImg" :src="userImage" width="40" height="40" class="rounded-full shadow-md cursor-pointer block"/>
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 12rem;">

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white text-center">
            <span class="ml-2 font-bold">{{ activeUserInfo.displayName }}</span>
          </li>

          <vs-divider class="m-1"/>

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="profile">
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4"/>
            <span class="ml-2">Perfil</span>
          </li>

          <vs-divider class="m-1"/>

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4"/>
            <span class="ml-2">Cerrar sesión</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
    <vx-tooltip v-else position="left" text="Inicie sesión para poder colocar una orden">
      <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer mr-2">
        <vs-avatar/>

        <vs-dropdown-menu>
          <div class="p-3 w-64">
            <h3 class="mb-2">Acceso</h3>
            <p class="mb-2 text-sm">Seleccione el método de acceso</p>
            <div class="flex flex-col items-center mt-4">

              <!-- GOOGLE -->
              <div class="flex flex-row items-center bg-google rounded-lg cursor-pointer h-16 w-48 md:w-64" @click="loginWithGoogle">
                <img class="m-2 h-8" src="@/assets/images/logo/GoogleIcon.png" alt="Acceso por Google">
                <div class="h-full w-px bg-white"></div>
                <div class="flex text-white items-center text-sm m-4 border-l-2 border-white">Acceder con Google</div>
              </div>

              <!-- facebook -->
              <div class="flex flex-row items-center bg-facebook rounded-lg cursor-pointer mt-3 h-16 w-48 md:w-64" @click="loginWithFacebook">
                <img class="m-2 h-8" src="@/assets/images/logo/facebookIcon.png" alt="Acceso por Google">
                <div class="h-full w-px bg-white"></div>
                <div class="flex text-white items-center text-sm m-4 border-l-2 border-white">Acceder con facebook</div>
              </div>

            </div>
          </div>
        </vs-dropdown-menu>

      </vs-dropdown>
    </vx-tooltip>
  </div>
</template>

<script>
  import firebase from 'firebase/app'
  import 'firebase/auth'

  export default {
    name: "User",
    data() {
      return {
        name: '',
        email: '',
        phone: '',
        codeSent: false,
        validationCode: '',
        registerPrompt: false
      }
    },
    computed: {
      currentUser() {
        return firebase.auth().currentUser;
      },
      loggedIn() {
        return this.$store.state.auth.isUserLoggedIn();
      },
      activeUserInfo() {
        return this.$store.state.AppActiveUser;
      },
      userImage() {
        if (this.$store.state.AppActiveUser.photoURL) {
          return this.$store.state.AppActiveUser.photoURL;
        } else if (this.$store.state.AppActiveUser.gender == 'F') {
          return require("@/assets/images/portrait/small/FemaleAvatar.png");
        } else {
          return require("@/assets/images/portrait/small/MaleAvatar.png");
        }
      }
    },
    methods: {
      checkLogin() {
        if (this.currentUser) {
          this.$vs.notify({
            title: 'Intento de acceso',
            text: 'Usted ya accedió a la tienda',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          });

          return false
        }
        return true
      },

      // Google login
      loginWithGoogle() {
        if (this.checkLogin) {
          this.$store.dispatch('auth/loginWithGoogle', {self: this, notify: this.$vs.notify})
        }
      },

      // Facebook login
      loginWithFacebook() {
        if (this.checkLogin) {
          this.$store.dispatch('auth/loginWithFacebook', {self: this, notify: this.$vs.notify})
        }
      },

      logout: function () {
        if (this.checkLogin) {
          this.$store.dispatch('auth/signOut', {self: this, notify: this.$vs.notify});
          this.$store.commit('UPDATE_USER_INFO', this.$store.state.userDefaults, {root: true});
        }
      },
      profile: function () {
        this.$router.push('/profile');
      },
      close: function () {
      },
    }
  }
</script>

<style scoped>
  .bg-facebook {
    background-color: #3B5998
  }

  .bg-google {
    background-color: #DD4B39
  }
</style>
